import { useQuery } from '@tanstack/react-query';
import { get } from 'lodash';
import { trackQueryError } from '@utils/sensor/apptracker';
import { getAlertDiagnosticsData } from '@src/api/aiAlerts';
import { setDiagnosticsData } from '@src/store/aiAlerts/actions';

const defaultValue = null;

function useFetchDiagnostics({ alertId = null, alertType = 'VIDEO_ALERT', enabled = true }) {
  return useQuery(
    ['ai-alert-diagnostics', alertId],
    () => {
      return getAlertDiagnosticsData({
        params: {
          alertType,
          alertId,
        },
      }).then((response) => {
        return get(response, ['data'], {});
      });
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      enabled: enabled && !!alertId,
      staleTime: 5 * 60 * 1000, // 5m
      placeholderData: defaultValue,
      onSuccess: (data) => {
        setDiagnosticsData(data); // adding to be safe
      },
      onError: (err) => {
        trackQueryError({ type: 'ai-alert-pre-diag', err });
      },
    },
  );
}

export default useFetchDiagnostics;
